export const GET_USERS_HOME_MODULES_CONNECTED       = 'GET_USERS_HOME_MODULES_CONNECTED'
export const GET_MODULE_SELECTED_HOME_MODULES       = 'GET_MODULE_SELECTED_HOME_MODULES'
export const GET_MODULE_ACTIVE_CLICK_HOME_MODULES   = 'GET_MODULE_ACTIVE_CLICK_HOME_MODULES'
export const GET_MODULE_ACTIVE_HOVER_HOME_MODULES   = 'GET_MODULE_ACTIVE_HOVER_HOME_MODULES'